// Styles
import './template-product.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateProduct = (context) => {
  const templateProductSection = context.closest('.shopify-section');
  if (!templateProductSection) return;

  const productsGalleries = templateProductSection.querySelectorAll('.product-gallery');
  productsGalleries.forEach(productsGallery => {
    new Swiper(productsGallery.querySelector('.product-gallery__container'), {
      loop: true,
      direction: productsGallery.dataset.pagination == 'bottom' ? 'horizontal' : 'vertical',
      pagination: {
        el: productsGallery.querySelector('.product-gallery__pagination'),
        type: productsGallery.dataset.paginationType,
        clickable: true
      }
    });
  });

  const productCapacitySelector = templateProductSection.querySelector('.product__meta__capacity');
  const relatedProductsDrawer = templateProductSection.querySelector('.product__meta__related-products');
  const relatedProductsDrawerOverlay = templateProductSection.querySelector('.product__meta__overlay');
  const relatedProductsDrawerCloseButton = templateProductSection.querySelector('.product__meta__related-products__close');
  if (productCapacitySelector && relatedProductsDrawer) {
    productCapacitySelector.addEventListener('click', () => {
      if (relatedProductsDrawer.classList.contains('open')) {
        relatedProductsDrawer.classList.remove('open');
        relatedProductsDrawerOverlay.classList.remove('visible');
      } else {
        relatedProductsDrawer.classList.add('open');
        relatedProductsDrawerOverlay.classList.add('visible');
      }
    });

    relatedProductsDrawerCloseButton.addEventListener('click', () => {
      relatedProductsDrawer.classList.remove('open');
      relatedProductsDrawerOverlay.classList.remove('visible');
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
    window.dAgency.initTemplateProduct(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
      window.dAgency.initTemplateProduct(el);
    });
  });
}
